// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1X6lO","requiredAsterisk":"Info_requiredAsterisk__2vJjF"};